import Swiper from "swiper";
import { Navigation, Pagination, Scrollbar } from "swiper/modules";

export default {
	swipers: [],
	mediaQuery: window.matchMedia("(max-width: 991px)"),
	listener: null,

	init() {
		const toggleSwiper = (e) => {
			if (e.matches) {
				if (this.swipers.length) return;

				const carousels = document.querySelectorAll(".services--cards");
				carousels.forEach((carousel) => {
					const swiper = new Swiper(carousel, {
						modules: [Navigation, Pagination, Scrollbar],
						loop: false,
						slidesPerView: 1.15,
						speed: 400,
						spaceBetween: 15,
						scrollbar: {
							el: ".swiper-scrollbar",
							draggable: true,
						},
						pagination: {
							el: ".featured-news-pagination",
							clickable: true,
						},
						navigation: {
							nextEl: ".featured-pages--next",
							prevEl: ".featured-pages--prev",
						},
						breakpoints: {
							768: {
								slidesPerView: 2.5,
								spaceBetween: 15,
							},
						},
					});

					this.swipers.push(swiper);
				});
			} else {
				this.destroy();
			}
		};

		this.listener = toggleSwiper;

		// Initial check
		toggleSwiper(this.mediaQuery);

		// Watch breakpoint changes
		this.mediaQuery.addEventListener("change", this.listener);
	},

	destroy() {
		this.swipers.forEach((swiper) => {
			swiper.destroy(true, true);
		});

		this.swipers = [];
	},
};
